import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
var CATALOG_PATH = '/czna-authorities/semantic-catalog';
var READ_PERM = 'czna-authorities.semantic-catalog.get';
/**
 * Settings nav button for the read-only ontology browser (CZNA-419 / WP-P6a).
 *
 * <p>Since CZNA-424 this is the <b>only</b> settings entry into the semantic model.
 * The MARC-catalog browser was folded into the ontology's field detail (it showed
 * the same 108 tags), and the outgoing single-layer semantic registry is no longer
 * advertised — its screen and route survive for inspection during P6b, but a
 * customer has no reason to see two doors to one thing.
 *
 * <p>Gated by {@code czna-authorities.semantic-catalog.get}, deliberately its own
 * permission rather than the registry's, so the two can be granted separately for
 * as long as both artifacts are served.
 */
var SemanticCatalogNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var stripes = useStripes();
    var handleClick = useCallback(function () {
        if (pathname !== CATALOG_PATH)
            history.push(CATALOG_PATH);
    }, [history, pathname]);
    if (!stripes.hasPerm(READ_PERM))
        return null;
    var isActive = pathname === CATALOG_PATH || pathname.startsWith("".concat(CATALOG_PATH, "/"));
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.semanticCatalog' }))));
};
export default SemanticCatalogNavButton;
